const caseGeneratorDanish = {
  header: {
    title: "Case Opslag Generator",
    description: "Lad AI'en hjælpe dig med at skabe et engagerende LinkedIn opslag baseret på din case"
  },
  customerBanner: {
    working: "Du genererer nu et case-opslag for"
  },
  input: {
    title: "Beskriv din case",
    placeholder: "Fortæl om din case eller historie. Det kan være en kundecase, et spændende møde, eller en anden oplevelse du gerne vil dele på LinkedIn..."
  },
  image: {
    title: "Vil du tilføje et billede?",
    gallery: "Vælg fra billedearkiv",
    upload: "Upload billede",
    camera: "Tag billede",
    remove: "Fjern billede"
  },
  buttons: {
    generate: "Generer opslag fra case",
    generating: "Genererer opslag...",
    retry: "Prøv igen",
    edit: "Rediger",
    remove: "Fjern billede",
    addImage: "Billede",
    save: "Gem ændringer",
    saving: "Gemmer",
    cancel: "Annuller",
    accept: "Accepter",
    fortryd: "Fortryd",
    scheduling: "Planlægger...",
    schedulePost: "Planløg opslag"
  },
  aiPrompt: {
    placeholder: "Beskriv hvordan case-opslaget skal forbedres...",
    editing: "Redigerer",
    send: "Send"
  },
  loading: {
    generating: "Genererer et LinkedIn opslag baseret på din case..."
  },
  messages: {
    error: "Der opstod en fejl ved generering af case-opslag. Prøv igen senere.",
    draftLoaded: "Din seneste case-kladde er blevet indlæst",
    fieldRequired: "Venligst indtast en case-beskrivelse for at generere et opslag",
    imageAdded: "Billede tilføjet!",
    imageRemoved: "Billede fjernet!",
    caseGenerated: "Case-opslag genereret!",
    savedChanges: "Ændringer gemt!",
    caseUpdated: "Case-opslag opdateret!",
    imageUploaded: "Billede uploadet og tilføjet!",
    caseScheduled: "Case-opslag planlagt til {formattedDate}",
    aiSelectedTime: "AI har valgt det optimale tidspunkt!",
    confirmDiscard: "Er du sikker på, at du vil kassere dette opslag? Alle ændringer vil gå tabt.",
    caseRegenerated: "Case-opslag regenereret!"
  },
  gallery: {
    title: "Vælg et billede",
    noImages: "Du har ingen billeder i dit arkiv.",
    goToArchive: "Gå til billedearkiv"
  },
  weekCalendar: {
    selectDay: "Vælg dag for dit opslag",
    selectTime: "Vælg tidspunkt for {day}",
    addPost: "Tilføj opslag",
    backToDays: "Tilbage til dage",
    schedulerNote: "Disse tidspunkter er konfigureret i din Scheduler men endnu ikke optaget af eksisterende opslag."
  },
  saveModal: {
    title: "Planlæg dit case-opslag",
    question: "Hvordan vil du planlægge dit case-opslag?",
    options: {
      weekly: {
        title: "Brug mit ugentlige skema",
        description: "Opslaget vil blive delt i henhold til din normale planlægning"
      },
      custom: {
        title: "Vælg selv tidspunkt",
        description: "Vælg præcis hvornår opslaget skal deles"
      },
      ai: {
        title: "Lad AI'en planlægge",
        description: "AI'en vælger det optimale tidspunkt baseret på LinkedIn statistikker"
      }
    },
    weekly: {
      confirm: "Dit opslag vil blive tilføjet til din normale planlægning og delt efter din ugentlige plan."
    },
    custom: {
      title: "Vælg dato og tidspunkt for dit opslag:"
    },
    buttons: {
      back: "Tilbage",
      confirm: "Bekræft",
      saving: "Gemmer..."
    },
    success: {
      weekly: "Dit case-opslag er gemt og planlagt til deling på LinkedIn!",
      custom: "Dit case-opslag er planlagt til deling på LinkedIn {date}!",
      ai: "Dit case-opslag er planlagt til deling på LinkedIn {date}!"
    }
  }
};

export default caseGeneratorDanish; 